export default "__VITE_ASSET__BebG_MG$__"